import styled, { css } from 'styled-components';

import { withProductListMapper } from 'ggApp/shared/components/cards/widgetProductCard/withProductAdapter';

import CarouselV1 from 'ggApp/shared/components/Carousel';

export const Root = styled.section`
    padding: 0 5%;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        padding: 0 16px;
    `};
    overflow-x: hidden;
`;

export const CardRoot = styled.div`
    background: ${({ theme }) => theme.colors['Level 1']};
    padding: ${({ theme }) => theme.spacers.XXL};
    padding-right: 0;
    border-radius: 8px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        padding: ${theme.spacers.L} 0 ${theme.spacers.L} ${theme.spacers.L};
    `};
`;

export const Title = styled.h4`
    color: ${(props) => props.theme.colors.Foreground};
    margin-bottom: ${(props) => props.theme.spacers.XXL};
    ${(props) => css(props.theme.typography.Headline)}
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-bottom: ${(props) => props.theme.spacers.L};
        ${theme.typography.Subheadline}
    `};
`;

export const Carousel = styled(withProductListMapper(CarouselV1))`
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        overflow-x: scroll;
        margin: -10px -16px -10px -10px;
    `};
`;
